import { geoFormModelToGeo, geoToGeoFormModel } from '../../../geo/components/form-geo-field/mappers';
import { Agent } from '../../../providers/api/dtos';
import { EditAgentRegistryFormModel } from '../../components/edit-agent-registry-form/EditAgentRegistryForm';

export const agentToEditAgentRegistryFormModel = (agent: Agent): EditAgentRegistryFormModel => ({
  fiscalCode: agent.fiscalCode || '',
  pecEmail: agent.email.pec || '',
  personalEmail: agent.email.personal || '',
  workEmail: agent.email.work || '',
  personalMobile: agent.mobile.personal || '',
  workMobile: agent.mobile.work || '',
  personalName: agent.realName?.name || '',
  workName: agent.name.name || '',
  personalSurname: agent.realName?.surname || '',
  workSurname: agent.name.surname || '',
  residenceAddress: geoToGeoFormModel(agent.address?.residence),
  shippingAddress: geoToGeoFormModel(agent.address?.shipping),
});

export const editAgentRegistryFormModelToAgent = (agentFormModel: EditAgentRegistryFormModel, existingAgent: Agent): Agent => ({
  ...existingAgent,
  name: {
    name: agentFormModel.workName.trim(),
    surname: agentFormModel.workSurname.trim(),
  },
  realName: (agentFormModel.personalName.trim() || agentFormModel.personalSurname.trim()) ? {
    name: agentFormModel.personalName.trim(),
    surname: agentFormModel.personalSurname.trim(),
  } : undefined,
  email: {
    work: agentFormModel.workEmail.trim() || undefined,
    personal: agentFormModel.personalEmail.trim(),
    pec: agentFormModel.pecEmail.trim() || undefined,
  },
  mobile: {
    personal: agentFormModel.personalMobile.trim(),
    work: agentFormModel.workMobile.trim() || undefined,
  },
  fiscalCode: agentFormModel.fiscalCode.trim() || undefined,
  address: {
    residence: geoFormModelToGeo(agentFormModel.residenceAddress),
    shipping: geoFormModelToGeo(agentFormModel.shippingAddress),
  },
});
